import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	accessToken: '', // The initial state for the access token
	rememberMe: false,
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAccessToken: (state, action) => {
			state.accessToken = action.payload;
		},
		clearAccessToken: (state) => {
			state.accessToken = '';
		},
		setRememberMe: (state, action) => {
			state.rememberMe = action.payload;
		},
		clearRememberMe: (state, action) => {
			state.rememberMe = false;
		},
	},
});

export const {
	setAccessToken,
	clearAccessToken,
	setRememberMe,
	clearRememberMe,
} = authSlice.actions;

export default authSlice.reducer;
